import { IonButton, IonInput, IonLabel, IonList, IonItem, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar 
  ,IonGrid, IonModal, IonBackButton, IonThumbnail
  ,IonRow, IonCard , IonCardSubtitle, IonCardTitle, IonCardContent
  ,IonCol, IonItemOptions, IonItemOption, IonImg, IonCardHeader, IonItemDivider, IonAlert
  ,IonListHeader, IonToggle, IonRadio, IonCheckbox, IonItemSliding, IonIcon, IonFooter, IonSegment, IonSegmentButton} from '@ionic/react';

import { close, checkmark, qrCodeOutline, arrowRedo, chevronBack, closeCircle  } from 'ionicons/icons';
import React, { useState, useEffect, Component } from 'react';
//import { useParams } from 'react-router';
import './DarForm.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import QrReader from 'react-qr-reader'
import ServerService from '../../../services/Server';

const DarForm: React.FC = () => {
const server = new ServerService();
const name:string = "B1-DAR Check Version";
const now = new Date();
const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();
const [showQrScan, setShowQrScan] = useState(true);
const [showDetail, setShowDetail] = useState(false);
const [showMsg, setShowMsg] = useState(false);
const [qrReader, setQrReader] = useState("");
const [barCode, setBarcode] = useState("");
const [docName, setDocName] = useState("");
const [docNo, setDocNo] = useState("");
const [revision, setRevision] = useState("");
const [lastRevision, setLastRevision] = useState("");
const [effectiveDate, setEffectiveDate] = useState("");
const [expireDate, setExpireDate] = useState("");
const [routeName, setRouteName] = useState("");
const [darNo, setDarNo] = useState("");
const [imgDocument, setImgDocument] = useState("");
const [txtDocument, setTxtDocument] = useState("");

const onScanQr = function(status:any) {
  setShowQrScan(false);
}
const onClickBarcodeQR = function(qr:any) {
  fetchDarInfo(qr);
}
const onClickBarcode = function(status:any) {
 setShowDetail(false);
 var result =  fetchDarInfo(barCode);
}
const handleScan = (data: any) => {
  if (data!=null && data != '') {
   setShowQrScan(true);
   setBarcode(data);
   onClickBarcodeQR(data);
  
  }
}
const handleError = (err: any) => {
  console.error(err)
 }

 const fetchDarInfo = async function(id:any) {
  const data = {
    darNo: id
  }
   await fetch(server.getFullUrl("rp/getDarReqInfo", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      //setDocName(result.data.name);
      //setDocNo(result.data.doc_no);
      //setRevision(result.data.versionlabel);
     // setEffectiveDate(result.data.effective_date);
     // setDarNo(result.data.dar_no);
      //setExpireDate(result.data.record_expire);
     // setRouteName(result.data.route_name);
     // setShowDetail(true);\
      if(result.success){
        fetchDocInfo(result);
      }else{
        setShowDetail(false);
        setShowMsg(true);
      }
     
     
    },
    (error) => {
     
    }
 ).catch(e => {

 })
).catch(e => {

})
 
}
const fetchDocInfo = async function(resultDar:any) {
  const data = {
    doc_id: resultDar.data.doc_id
  }
   await fetch(server.getFullUrl("rp/getDocById", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
    
     
      onsetValue(result, resultDar);
     
    },
    (error) => {
     
    }
 ).catch(e => {

 })
).catch(e => {

})

}
const onsetValue = async function(result:any, resultDoc:any) {

  setDocName(resultDoc.data.name);
  setDocNo(resultDoc.data.doc_no);
  setRevision(resultDoc.data.versionlabel);
  setEffectiveDate(resultDoc.data.effective_date);
  setDarNo(resultDoc.data.dar_no);
  setExpireDate(resultDoc.data.record_expire);
  setRouteName(resultDoc.data.route_name);

  setLastRevision(result.data.version);
  console.log(lastRevision);
  console.log(revision);
  
  if(result.data.version == resultDoc.data.versionlabel){
    setImgDocument('assets/img/filecorrect.png');
    setTxtDocument('This document is lastest version.');
  }else{
    setImgDocument('assets/img/fileincorrect.png');
    setTxtDocument('This document is older version.');
  }

  setShowDetail(true);
  setShowMsg(false);
}
useEffect(() => {

}, [revision, lastRevision,imgDocument, txtDocument])
const showDarDetail = function(){
  if(showDetail){
    return (
      <div className="card-middel">
            <IonCard>        
            <IonCardHeader>
            <IonCardTitle><IonImg className="img-header" src={imgDocument}></IonImg>{txtDocument}</IonCardTitle>
            <IonCardSubtitle></IonCardSubtitle>
            <IonCardSubtitle> <b>Document Number :</b> {docNo}</IonCardSubtitle>
            <IonCardSubtitle><b>Document Name :</b> {docName}</IonCardSubtitle>
            <IonCardSubtitle><b>Current Revision :</b> {revision}</IonCardSubtitle>
            <IonCardSubtitle><b>Last Revision :</b> {lastRevision}</IonCardSubtitle>
            <IonCardSubtitle><b>Dar Number :</b> {darNo}</IonCardSubtitle>
            <IonCardSubtitle><b>Effective Date :</b> {effectiveDate}</IonCardSubtitle>
            <IonCardSubtitle><b>Expire Date :</b> {expireDate}</IonCardSubtitle>
            <IonCardSubtitle><b>Route Name :</b> {routeName}</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent></IonCardContent>
            </IonCard>
            </div>
    )
    }
}
const showDarMsg = function(){
  if(showMsg){
    return (
      <IonCard>   
        <IonCardHeader>
        <IonCardTitle>Document not found.</IonCardTitle>
      </IonCardHeader>
      </IonCard>   
    )
  }
 
}

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonModal isOpen={!showQrScan}>
      <IonListHeader>
      <IonLabel>Scan QR Code</IonLabel>
      <IonButton onClick={() => setShowQrScan(true)}><IonIcon icon={closeCircle}></IonIcon></IonButton>
      </IonListHeader>
    
        <IonContent>
        
        <div hidden={showQrScan}>
          <QrReader
            delay={1000}
            onError={handleError}
            onScan={handleScan}
            resolution={1200}
            style={{ width: '100%' }}
          />
        </div>
        </IonContent>
      </IonModal>

        <IonList>
        <IonItem>
            <IonLabel className="f-header p1" position="stacked">Dar Number</IonLabel>
            <IonInput value={barCode} onIonChange={e => {setBarcode(e.detail.value)}}> </IonInput>
          </IonItem>
        </IonList>
        <IonGrid>
  <IonRow>
    <IonCol>
      <IonButton color="secondary" expand="block" onClick={(e) => onScanQr("")}><IonIcon icon={qrCodeOutline}></IonIcon> <IonLabel>Scan QR</IonLabel></IonButton>
    </IonCol>
    <IonCol>
    <IonButton color="primary" expand="block" onClick={(e) => onClickBarcode("")}><IonIcon icon={arrowRedo}></IonIcon>Submit</IonButton>
    </IonCol>
  </IonRow>
</IonGrid>
           {showDarMsg()}
           {showDarDetail()}
      </IonContent>
     
    </IonPage>
  );
};

export default DarForm;
